import React from 'react';
import { connect } from 'react-redux';
import classes from './BranchesView.scss';
import api from '../../../utils/api';
import BranchesTableView from './BranchesTableView';
import { push } from 'connected-react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import RaisedButton from 'material-ui/RaisedButton';
import { Toolbar, ToolbarGroup, ToolbarSeparator } from 'material-ui/Toolbar';

class BranchesView extends React.Component {
    onSubmit = values => {};

    componentWillReceiveProps = nextProps => {};

    constructor(props) {
        super(props);
        this.state = {
            showAddDialog: false,
            showAddArticlesDialog: false,
            file: null,
        };
    }

    componentDidMount = () => {
        this.props.fetchBranches();
    };

    addBranch = () => {
        this.props.addBranch();
    };

    deleteBranch = branch_id => () => {
        this.props.deleteBranch({ branch_id: branch_id });
    };

    uploadArticles = branch_id => () => {
        this.props.uploadArticles({ branch_id: branch_id });
    };

    showUploadDialog = () => {
        this.props.push('/branches/upload');
    };

    render = () => {
        return (
            <div className={classes.container}>
                <div style={{ position: 'fixed', bottom: '80px', right: '40px' }}>
                    <FloatingActionButton onMouseUp={this.addBranch}>
                        <ContentAdd />
                    </FloatingActionButton>
                </div>
                <h2>Filialen</h2>
                <Toolbar>
                    <ToolbarGroup firstChild={true} />
                    <ToolbarGroup>
                        <ToolbarSeparator />
                        <RaisedButton
                            label="Filialübergreifender Artikelupload"
                            primary={true}
                            onClick={this.showUploadDialog}
                        />
                    </ToolbarGroup>
                </Toolbar>
                <BranchesTableView
                    branches={this.props.branches}
                    uploadArticles={this.uploadArticles}
                    isFetching={this.props.isFetching}
                    deleteBranch={this.deleteBranch}
                />
                {this.props.children}
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    branches: state.branches.get('items'),
    isUploading: state.branches.get('isUploading'),
    isFetching: state.branches.get('isFetching'),
});

const mapDispatchToProps = dispatch => ({
    push: payload => dispatch(push(payload)),
    fetchBranches: () => dispatch(api.actions.branches.fetchBranches()),
    addBranch: payload => dispatch(push('/branches/add')),
    uploadArticles: payload => dispatch(push('/branches/' + payload.branch_id + '/upload')),
    deleteBranch: payload => dispatch(push('/branches/' + payload.branch_id + '/delete')),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BranchesView);
